// Auto-generated by scripts/update-post-metadata.ts. Do not edit manually.
import {
  isPostVisible,
  shouldShowUnpublishedPosts,
} from "@/lib/blog/postVisibility";

export type BlogPostMeta = {
  slug: string;
  title: string;
  excerpt?: string;
  readTime?: string;
  publishedAt?: string;
  intendedPublishedAt?: string;
  draft?: boolean;
  status?: string;
  modifiedAt?: string;
  seoTitle?: string;
  seoDescription?: string;
  legacyUrl?: string;
  authorName?: string;
  authorSlug?: string;
  mainImageUrl?: string;
  mainImageAlt?: string;
  mainImageCaption?: string;
  tags?: string[];
};

export const allPosts: BlogPostMeta[] = [
  {
    title: "Plausible Accessibility: Where AI Still Falls Short and Who to Call Instead",
    slug: "plausible-accessibility",
    excerpt: "AI builds the most likely interface and accessibility lives in the specific one. Here is where that gap still fails disabled people and when to bring in a specialist or test with the people who use what you build.",
    readTime: "14 min read",
    publishedAt: "2026-10-15T00:00:00.000Z",
    seoTitle: "Plausible Accessibility: Where AI Still Falls Short",
    seoDescription: "AI builds the most likely interface, but accessibility lives in the specific one. Where that gap still fails disabled people and when to call a specialist.",
    authorName: "Petri Lahdelma",
    authorSlug: "petri-lahdelma",
    mainImageUrl: "/blog/plausible-accessibility/hero-stencil-at-desk.webp",
  },
  {
    title: "From DesignOps to AgentOps",
    slug: "from-designops-to-agentops",
    excerpt: "As AI agents enter product delivery, design-system leaders become operators of context, contracts, review loops and trust.",
    readTime: "8 min read",
    publishedAt: "2026-06-19T08:00:00.000Z",
    status: "scheduled",
    authorName: "Petri Lahdelma",
    authorSlug: "petri-lahdelma",
    mainImageUrl: "/blog/agentic-design-systems/hero-05-agentops.png",
    mainImageAlt: "Bridge from DesignOps through context operator to AgentOps",
    tags: ["DesignOps","AgentOps","Design Leadership","AI"],
  },
  {
    title: "The Minimum Viable Agent-Ready Design System",
    slug: "the-minimum-viable-agent-ready-design-system",
    excerpt: "You do not need a giant enterprise design system to work safely with AI. You need a small, enforceable system that agents can read and humans can trust.",
    readTime: "10 min read",
    publishedAt: "2026-06-15T08:00:00.000Z",
    status: "scheduled",
    seoTitle: "The Minimum Viable Agent-Ready Design System",
    authorName: "Petri Lahdelma",
    authorSlug: "petri-lahdelma",
    mainImageUrl: "/blog/agentic-design-systems/hero-04-mvp.png",
    mainImageAlt: "Six-layer minimum viable agent-ready design system stack",
    tags: ["Design Systems","AI Governance","Product Design","Frontend"],
  },
  {
    title: "Component Contracts Are Where Taste Becomes Infrastructure",
    slug: "component-contracts-are-where-taste-becomes-infrastructure",
    excerpt: "Taste does not scale by explanation alone. In agentic design systems, it has to become contracts, examples and verification.",
    readTime: "14 min read",
    publishedAt: "2026-06-11T08:00:00.000Z",
    status: "scheduled",
    seoTitle: "Component Contracts: Where Taste Becomes Infrastructure",
    authorName: "Petri Lahdelma",
    authorSlug: "petri-lahdelma",
    mainImageUrl: "/blog/agentic-design-systems/hero-03-contracts.png",
    mainImageAlt: "Split panel: documentation explains, contracts constrain with v1 and v2 layers",
    tags: ["Component Contracts","Design Systems","AI","Frontend Architecture"],
  },
  {
    title: "Tools, Harnesses and Skills: The Missing Model for Design Systems",
    slug: "tools-harnesses-and-skills-the-missing-model-for-design-systems",
    excerpt: "Most agentic design workflow conversations confuse the workspace, the operating model and the reusable capability. Separating them changes how teams scale.",
    readTime: "9 min read",
    publishedAt: "2026-06-07T08:00:00.000Z",
    status: "scheduled",
    seoTitle: "Tools, Harnesses and Skills for Design Systems",
    authorName: "Petri Lahdelma",
    authorSlug: "petri-lahdelma",
    mainImageUrl: "/blog/agentic-design-systems/hero-02-tools-harness-skills.png",
    mainImageAlt: "Three-layer diagram: tools workspace, harness boundaries, skills playbooks",
    tags: ["Design Systems","Agentic Workflows","Figma","Storybook"],
  },
  {
    title: "Agentic Design Systems Need Operating Models, Not More Components",
    slug: "agentic-design-systems-need-operating-models-not-more-components",
    excerpt: "AI does not make design systems obsolete. It exposes whether they were ever operational in the first place.",
    readTime: "15 min read",
    publishedAt: "2026-06-03T08:00:00.000Z",
    status: "scheduled",
    seoTitle: "Agentic Design Systems Need Operating Models",
    seoDescription: "AI exposes whether a design system was ever operational. Agents need a repeatable loop of intent, rules, output and evidence that humans already trust.",
    authorName: "Petri Lahdelma",
    authorSlug: "petri-lahdelma",
    mainImageUrl: "/blog/agentic-design-systems/hero-01-operating-models.png",
    mainImageAlt: "Circular diagram of the agentic operating loop: intent, rules, output, evidence, better rules",
    tags: ["Design Systems","AI","Agentic Workflows","DesignOps"],
  },
  {
    title: "From Tokens to Thinking Systems: Making AI-Native Design Systems Actually Work",
    slug: "from-tokens-to-thinking-systems-making-ai-native-design-systems-actually-work",
    excerpt: "A practical blueprint for AI-native design systems that LLMs can actually execute: tokens, schema and generative rules as explicit contracts.",
    readTime: "9 min read",
    publishedAt: "2025-12-29T08:16:00.000Z",
    seoTitle: "From Tokens to Thinking Systems: AI-Native Design Systems",
    authorName: "Petri Lahdelma",
    authorSlug: "petri-lahdelma",
    mainImageUrl: "https://cdn.sanity.io/images/ai4cwr0g/digitaltableteur-blog/6b129891b9e49f23f12d17b7822f66ea172548d1-900x512.png?w=1600",
  },
  {
    title: "The Evolutionary Difference Between Constructive and Constrictive Criticism",
    slug: "the-evolutionary-difference-between-constructive-and-constrictive-criticism",
    excerpt: "The Evolutionary Difference Between Constructive and Constrictive Criticism",
    readTime: "5 min read",
    publishedAt: "2025-12-03T07:45:00.000Z",
    seoTitle: "Constructive vs Constrictive Criticism | Digitaltableteur",
    seoDescription: "Feedback works like a biological signal that can guide, distort, expand or collapse what comes next. Why some criticism grows people and some shrinks them.",
    authorName: "Petri Lahdelma",
    authorSlug: "petri-lahdelma",
  },
  {
    title: "Branding Design Systems",
    slug: "branding-design-systems-essay",
    excerpt: "Branding a design system is not a logo exercise. It is how you encode judgment so strangers ship UI that still feels like you.",
    readTime: "9 min read",
    publishedAt: "2025-11-26T18:43:00.000Z",
    authorName: "Petri Lahdelma",
    authorSlug: "petri-lahdelma",
  },
  {
    title: "Design System Meets AI: Building the Self-Evolving Component Library Pt 2",
    slug: "design-system-meets-ai-building-the-self-evolving-component-library-pt-2",
    excerpt: "A 5-part series exploring how design systems transform in the age of AI.",
    readTime: "4 min read",
    publishedAt: "2025-11-23T04:38:00.000Z",
    seoTitle: "Self-Evolving Component Libraries, Part 2 | Digitaltableteur",
    seoDescription: "Part 2 of a series on design systems and AI: why AI as an enhancement layer changes nothing and how to build a system that intelligence can work inside.",
    authorName: "Petri Lahdelma",
    authorSlug: "petri-lahdelma",
  },
  {
    title: "Design System Meets AI: Building the Self-Evolving Component Library Pt 1",
    slug: "design-system-meets-ai-building-the-self-evolving-component-library-pt-1",
    excerpt: "A 5-part series exploring how design systems transform in the age of AI.",
    readTime: "4 min read",
    publishedAt: "2025-11-20T22:08:00.000Z",
    seoTitle: "Self-Evolving Component Libraries, Part 1 | Digitaltableteur",
    seoDescription: "Part 1 of a series on design systems and AI: systems built for order and governance were never designed for intelligence. Here is what has to change.",
    authorName: "Petri Lahdelma",
    authorSlug: "petri-lahdelma",
  },
  {
    title: "A Biography",
    slug: "petri-lahdelma-bio",
    excerpt: "From a small suburb to leading global design systems.",
    readTime: "3 min read",
    publishedAt: "2025-06-15T00:00:00.000Z",
    seoDescription: "A biography of Petri Lahdelma, a Finnish designer and systems thinker: from a suburb of Turku through two decades of agencies, startups and design systems.",
    authorName: "Petri Lahdelma",
    authorSlug: "petri-lahdelma",
  },
  {
    title: "Digital Craftsmanship",
    slug: "digital-craftsmanship",
    excerpt: "Thoughts on maintaining quality in a hurry-up culture.",
    readTime: "4 min read",
    publishedAt: "2025-06-10T00:00:00.000Z",
    seoDescription: "Keeping quality in a hurry-up culture: what gets lost between shipping faster and scaling bigger and why craft is still the difference people feel.",
    authorName: "Petri Lahdelma",
    authorSlug: "petri-lahdelma",
    mainImageUrl: "https://cdn.sanity.io/images/ai4cwr0g/digitaltableteur-blog/46eb4a68c7bd8e08f23cb83b8ebba0a73925ed34-1440x962.jpg?w=1600",
  },
  {
    title: "MCP, Design Systems and Generative UI",
    slug: "figma-mcp-design-systems",
    excerpt: "How Figma's MCP server speeds up design-to-code workflows.",
    readTime: "4 min read",
    publishedAt: "2025-06-05T00:00:00.000Z",
    seoDescription: "How Figma's MCP server and machine-readable component metadata speed up design-to-code work and turn handoff into a pipeline the components carry.",
    authorName: "Petri Lahdelma",
    authorSlug: "petri-lahdelma",
    mainImageUrl: "https://cdn.sanity.io/images/ai4cwr0g/digitaltableteur-blog/f89b3b77b080fe3d371cd0153eeb30d49429aaeb-1536x1024.webp?w=1600",
  },
  {
    title: "Workflow Tips",
    slug: "workflow-tips",
    excerpt: "A behind-the-scenes look at how Digitaltableteur keeps projects moving.",
    readTime: "3 min read",
    publishedAt: "2025-05-12T00:00:00.000Z",
    seoDescription: "Workflow tips for designers working with automation and AI tooling: shared metadata, semantic design systems and closer collaboration with developers.",
    authorName: "Petri Lahdelma",
    authorSlug: "petri-lahdelma",
    mainImageUrl: "https://cdn.sanity.io/images/ai4cwr0g/digitaltableteur-blog/ff2754d3228646d629b688b6ab7406838576d841-1536x1024.webp?w=1600",
  },
  {
    title: "Digitaltableteur Field Notes: In Search of Impact",
    slug: "in-search-of-impact",
    excerpt: "How a solo studio delivers enterprise-scale outcomes with boutique precision.",
    readTime: "4 min read",
    publishedAt: "2025-02-11T00:00:00.000Z",
    seoTitle: "In Search of Impact: Field Notes | Digitaltableteur",
    seoDescription: "Field notes on how a one-person studio blends strategy, design and engineering without handoffs to deliver enterprise-scale outcomes with boutique precision.",
    authorName: "Petri Lahdelma",
    authorSlug: "petri-lahdelma",
    mainImageUrl: "https://cdn.sanity.io/images/ai4cwr0g/digitaltableteur-blog/2c4621941096cd03ba2299862b591692feaf5854-1024x1024.png?w=1600",
  },
  {
    title: "Designing in 2025",
    slug: "designing-in-2025",
    excerpt: "Navigating the AI-assisted creative landscape.",
    readTime: "5 min read",
    publishedAt: "2025-02-09T00:00:00.000Z",
    seoDescription: "After two decades in design, a look at AI-assisted tools in 2025 and why design stays a deeply human act: the way to care for people at scale.",
    authorName: "Petri Lahdelma",
    authorSlug: "petri-lahdelma",
  },
  {
    title: "Thoughts on Future Branding",
    slug: "thoughts-on-future-branding",
    excerpt: "Exploring branding in the age of AI and exponential design.",
    readTime: "6 min read",
    publishedAt: "2018-06-07T00:00:00.000Z",
    seoDescription: "How branding changes in the age of AI and exponential design: from logos and guidelines to subtler stories told on the platforms people already use.",
    authorName: "Petri Lahdelma",
    authorSlug: "petri-lahdelma",
    mainImageUrl: "https://cdn.sanity.io/images/ai4cwr0g/digitaltableteur-blog/9460b2174dd7707b21408f68dfb03bcf63050d53-794x450.png?w=1600",
  }
];

export const getVisiblePosts = (options?: { showUnpublished?: boolean }) =>
  allPosts.filter((post) =>
    isPostVisible(post, options?.showUnpublished ?? shouldShowUnpublishedPosts()),
  );

export const getPostMetaBySlug = (
  slug?: string | null,
  options?: { showUnpublished?: boolean },
) =>
  slug
    ? getVisiblePosts(options).find((post) => post.slug === slug)
    : undefined;
